document.addEventListener('alpine:init', () => {
    Alpine.data('masonryGallery', () => ({
        columns: 1,
        handleResize: null,
        init() {
            this.columns = this.parseColumns();
            this.applyColumns();
            this.handleResize = () => {
                this.columns = this.parseColumns();
                this.applyColumns();
            };
            window.addEventListener('resize', this.handleResize, { passive: true });
        },
        destroy() {
            if (this.handleResize) {
                window.removeEventListener('resize', this.handleResize);
            }
        },
        parseColumns() {
            const raw = this.$el.dataset.masonryCols || '';
            const parsed = parseInt(raw, 10);
            return Number.isFinite(parsed) && parsed > 0 ? parsed : 1;
        },
        applyColumns() {
            this.$el.style.columnCount = String(this.columns);
            this.$el.style.columnGap = 'var(--gallery-spacing)';
        },
    }));
});
